const StorageIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 16.853">
            <g id="Group_7905" data-name="Group 7905" transform="translate(0 0)">
                <g id="Group_7904" data-name="Group 7904" transform="translate(0 0)">
                    <path
                        id="Path_3381"
                        data-name="Path 3381"
                        d="M.375,8.541a4.133,4.133,0,0,0,4.392,3.812H16.375A2.657,2.657,0,0,0,19.2,9.9a2.657,2.657,0,0,0-2.824-2.45h-.941V5c0-2.555-2.387-4.627-5.333-4.627-2.845,0-5.169,1.92-5.324,4.356C2.35,4.731.375,6.436.375,8.541Z"
                        transform="translate(0.213 0.213)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                    <line
                        id="Line_206"
                        data-name="Line 206"
                        y1="11.17"
                        transform="translate(9.853 5.095)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <line
                        id="Line_207"
                        data-name="Line 207"
                        y1="4.373"
                        x2="3.137"
                        transform="translate(6.716 5.094)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <line
                        id="Line_208"
                        data-name="Line 208"
                        x1="3.137"
                        y1="4.373"
                        transform="translate(9.853 5.094)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                </g>
            </g>
        </svg>
    );
};

export default StorageIcon;
